var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from 'mobx';
import { BaseService, Injectable } from './service.base';
export let SearchFieldService = class SearchFieldService extends BaseService {
    value = undefined;
    constructor() {
        super();
        makeObservable(this);
    }
    handleChange = e => {
        this.self.value = e.target.value;
    };
    handleClear = () => {
        this.self.value = undefined;
    };
};
__decorate([
    observable,
    __metadata("design:type", String)
], SearchFieldService.prototype, "value", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFieldService.prototype, "handleChange", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], SearchFieldService.prototype, "handleClear", void 0);
SearchFieldService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], SearchFieldService);
